import { DataTable } from "mantine-datatable";
import React, { useEffect, useState } from "react";
import CustomPagination from "../../components/Layouts/CustomPagination";
import { AiFillEye } from "react-icons/ai";
import HistoryService from "../../service/history.service";
import Swal from "sweetalert2";
import { date } from "yup";
import DateRangePicker from "../../components/Layouts/DateRangePicker";
import moment from "moment";
import DashboardService from "../../service/dashboard.service";
import DropdownCustom from "../../components/DropdownCustom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FaRegCopy } from "react-icons/fa";
// import DateRangePicker from "react-bootstrap-daterangepicker";
// import 'bootstrap/dist/css/bootstrap.css';
// import "bootstrap-daterangepicker/daterangepicker.css";

function History() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  // const [allData, setAllData] = useState([]);
  const [page, setPage] = useState(1);
  const PAGE_SIZES = [10, 20, 30, 50, 100];
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);
  const [totalData, setTotalData] = useState(0);
  const [date, setDate] = useState();
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [expandedReceiverRows, setExpandedReceiverRows] = useState({});
  const [isCopied, setIsCopied] = useState("");
  const [isFirst, setIsFirst] = useState(false);

  const toggleRow = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the boolean for this row
    }));
  };

  const toggleReceiverRow = (id) => {
    setExpandedReceiverRows((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the boolean for this row
    }));
  };
  // const [startDate, setStartDate] = useState(new Date());
  // const [endDate, setEndDate] = useState(new Date());
  // const UserDataTable = [
  //   {
  //     id: 1,
  //     country: "India",
  //     provider: "Jio",
  //     numberOfuser: "2",
  //     delivery: "4",
  //     message: "Hello",
  //     date: "09/10/2024",
  //   },
  //   {
  //     id: 2,
  //     country: "US",
  //     provider: "VI",
  //     numberOfuser: "5",
  //     delivery: "1",
  //     message: "Hello",
  //     date: "09/10/2024",
  //   },
  //   {
  //     id: 3,
  //     country: "Canada",
  //     provider: "Airtel",
  //     numberOfuser: "3",
  //     delivery: "7",
  //     message: "Hello",
  //     date: "09/10/2024",
  //   },
  //   {
  //     id: 4,
  //     country: "Germany",
  //     provider: "Bsnl",
  //     numberOfuser: "9",
  //     delivery: "5",
  //     message: "Hello",
  //     date: "09/10/2024",
  //   },
  //   {
  //     id: 5,
  //     country: "Uk",
  //     provider: "Jio",
  //     numberOfuser: "7",
  //     delivery: "9",
  //     message: "Hello",
  //     date: "09/10/2024",
  //   },
  // ];

  const showMessage = (msg, type) => {
    const toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      customClass: { container: "toast" },
    });
    toast.fire({
      icon: type,
      title: "data not found",
      padding: "10px 20px",
    });
  };

  const handleChange = (type, page) => {
    const total = totalData / pageSize;
    const newPage = Math.ceil(total);
    if (type === "Next") {
      if (page !== newPage) {
        setPage(page + 1);
      }
    } else if (type === "Previous") {
      if (page !== 1) {
        setPage(page - 1);
      }
    } else if (type === "First") {
      if (page !== 1) {
        setPage(1);
      }
    } else if (type === "Last") {
      if (page !== newPage) {
        setPage(newPage);
      }
    } else {
      setPage(page);
    }
  };

  const getHistory = async () => {
    setIsFirst(true);
    if (isFirst) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
    // const { date, pageNumber, pageSize } = values;
    console.log("date", date);

    const formattedDate =
      date !== "" && date !== undefined && date !== "Invalid date"
        ? moment(date, "YYYY-MM-DD").valueOf()
        : "";
    try {
      const response = await HistoryService.getHistory(
        formattedDate,
        page,
        pageSize,
        selectedCountry
      );

      setData(response.data.apiresponse.data.history);
      setTotalData(response.data.apiresponse.data.total);
      // setAllData(response.data.apiresponse.data);
    } catch (error) {
      console.log("error", error);

      showMessage(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  console.log("daddsadsadas", data);

  useEffect(() => {
    getHistory();

    const intervalId = setInterval(() => {
      setIsFirst(false);
      getHistory();
    }, 5000);

    return () => clearInterval(intervalId);
  }, [date, page, pageSize, selectedCountry]);

  const handleDataPerPage = (e) => {
    setPageSize(e.target.value);
  };

  const fetchCountries = async () => {
    try {
      const response = await DashboardService.getCountry();
      const countries = response.data.apiresponse.data;
      const options = countries.map((item) => ({
        value: item,
        label: item,
      }));

      const newObject = [{ value: "", label: "All" }, ...options];

      setCountryOptions(newObject);
    } catch (error) {
      console.error("Failed to fetch countries:", error);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const handleDateChange = (selectedDate) => {
    const date = moment(selectedDate.target.value).format("YYYY-MM-DD");
    setDate(date);
  };

  const handleClick = (selectedDate) => {
    const date = moment(selectedDate.target.value).format("YYYY-MM-DD");
    setDate(date);
    setSelectedCountry("");
  };

  const handleChangeCountry = async (e) => {
    setSelectedCountry(e);
  };

  const handleCopy = (id) => {
    setIsCopied(id);

    setTimeout(() => {
      setIsCopied("");
    }, 1000);
  };

  return (
    <>
      <h5 className="text-lg font-semibold dark:text-white-light mb-3">
        History
      </h5>

      {/* <DateRangePicker
        initialSettings={{ startDate: "09/01/2024", endDate: "10/01/2024" }}
        // renges={selectionRange}
        // onchange={handleSelect}
      >
        <button className="border-2 rounded-md p-2">Select a Date</button>
      </DateRangePicker> */}

      <div className="flex justify-end">
        <div className="mt-1 mr-2">
          {countryOptions.length > 0 && (
            <DropdownCustom
              data={countryOptions}
              setData={handleChangeCountry}
              name="Country"
            />
          )}
        </div>
        <input
          type="date"
          value={date}
          onChange={handleDateChange}
          className="mt-1 block border border-gray-300 rounded-md p-2 w-54 mb-4"
        />
        {/* <button
          className="bg-transparent border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white font-bold px-4 h-10 mt-1 ml-2 rounded"
          onClick={handleClick}
        >
          Clear
        </button> */}
      </div>

      <DataTable
        noRecordsText="No results match your search query"
        highlightOnHover
        className="whitespace-nowrap table-hover min-w-[780px]"
        records={data}
        columns={[
          {
            accessor: "id",
            title: "ID",
            // sortable: true,
            render: ({ id }, index) => (
              <div>
                <span>{(page - 1) * pageSize + index + 1}</span>
              </div>
            ),
          },
          {
            accessor: "country",
            title: "Country",
            render: ({ country }) => (
              <div className="">
                <span className="!text-xs">{country ? country : "--"}</span>
              </div>
            ),
          },
          {
            accessor: "provider",
            title: "Network",
            render: ({ provider }) => (
              <div className="">
                <span className="!text-xs">{provider ? provider : "--"}</span>
              </div>
            ),
          },
          {
            accessor: "toMobilenumber",
            title: "Mobile Number",
            render: ({ toMobilenumber, id }) => {
              const isExpanded = expandedRows[id]; // Check if the current row is expanded
              const numbersToShow = isExpanded
                ? toMobilenumber
                : toMobilenumber?.slice(0, 3); // Show all or first two numbers

              return (
                <div className="max-w-[210px] text-wrap text-ellipsis">
                  <span className="!text-xs">
                    {numbersToShow?.length > 0
                      ? numbersToShow?.join(", ")
                      : "--"}
                    {toMobilenumber?.length > 4 && (
                      <button
                        onClick={() => toggleRow(id)}
                        className="text-blue-500 ml-2"
                      >
                        {isExpanded ? "Show Less" : "Show More"}
                      </button>
                    )}
                  </span>
                </div>
              );
            },
          },
          {
            accessor: "gettingDelivery",
            title: "Delivered",
            render: ({ gettingDelivery }) => (
              <div className="">
                <span className="!text-xs">
                  {gettingDelivery ? gettingDelivery : "--"}
                </span>
              </div>
            ),
          },
          {
            accessor: "receiveMobileNumber",
            title: "Receiver",
            render: ({ receiveMobileNumber, id }) => {
              const isExpanded = expandedReceiverRows[id]; // Check if the current row is expanded
              const numbersToShow = isExpanded
                ? receiveMobileNumber
                : receiveMobileNumber?.slice(0, 3); // Show all or first two numbers

              return (
                <div className="max-w-[210px] text-wrap text-ellipsis">
                  <span className="!text-xs">
                    {numbersToShow?.length > 0
                      ? numbersToShow?.join(", ")
                      : "--"}
                    {receiveMobileNumber?.length > 4 && (
                      <button
                        onClick={() => toggleReceiverRow(id)}
                        className="text-blue-500 ml-2"
                      >
                        {isExpanded ? "Show Less" : "Show More"}
                      </button>
                    )}
                  </span>
                </div>
              );
            },
          },
          {
            accessor: "message",
            title: "Message",
            render: ({ message, id }) => (
              <div className="flex gap-2 items-center flex-wrap">
                <span className="!text-xs">{message ? message : "--"}</span>
                <CopyToClipboard text={message}>
                  {isCopied === id ? (
                    <div className="border border-gray-500 text-gray-500 py-[1px] px-1 text-xs rounded-md">
                      Copied
                    </div>
                  ) : (
                    <FaRegCopy
                      className="cursor-pointer h-4 w-4 text-gray-500 hover:text-gray-700"
                      onClick={() => handleCopy(id)}
                    />
                  )}
                </CopyToClipboard>
              </div>
            ),
          },
          {
            accessor: "senderId",
            title: "Sender ID",
            render: ({ senderId }) => (
              <div className="">
                <span className="!text-xs">{senderId ? senderId : "--"}</span>
              </div>
            ),
          },
          {
            accessor: "creationDate",
            title: "Date",
            render: ({ creationDate }) => (
              <div className="">
                <span className="!text-xs">
                  {creationDate !== "0" &&
                  creationDate !== 0 &&
                  creationDate !== "" &&
                  creationDate !== null &&
                  creationDate !== undefined &&
                  creationDate !== "null"
                    ? moment(Number(creationDate)).format("DD/MM/YYYY HH:mm")
                    : "--"}
                </span>
              </div>
            ),
          },
        ]}
        totalRecords={totalData}
        recordsPerPage={pageSize}
        onPageChange={(p) => setPage(p)}
        recordsPerPageOptions={PAGE_SIZES}
        onRecordsPerPageChange={setPageSize}
        minHeight={200}
        loading={isLoading}
        fetching={isLoading}
      />
      <CustomPagination
        total={totalData}
        page={page}
        handleChange={handleChange}
        dataPerPage={pageSize}
        handleDataPerPage={handleDataPerPage}
        PAGE_SIZES={PAGE_SIZES}
      />
    </>
  );
}

export default History;
